
define('text!templates/pages/dashboard/index.ejs',[],function () { return '<div class="dashboard-column-1">\n    <div id="dashboard-news-container"></div>\n</div>\n\n<div class="dashboard-column-2">\n    <div id="dashboard-sessions-container"></div>\n    <div id="dashboard-balance-container"></div>\n    <div id="dashboard-notifies-container"></div>\n</div';});

